const triggerPartialRegistration = (sessionId, country, lang, mtcn, applicationSource,password, countryCode, phone, givenName, surname1, surname2, externalRefId, enableWhatsAppOption, showSuccessScreen, email, token, mailNotification) => {
    const latinCountries = ['MX']
    const customerHeaders = {
        "Content-Type" : `application/json`,
        "x-wu-correlationId": `web-` + generateUniqueID(),
        "x-wu-externalRefId": externalRefId || `web-` + generateUniqueID(),
        "WuCountryCode": country, // receiverCountry
        "WuLanguageCode": lang,
        "x-wu-sessionId": sessionId,
        "x-wu-session-version": 1,
        "accept": `application/json`,
        "applicationSource":applicationSource,
        "Accept-Language": `${lang}-${country}`,
        "x-wu-identity": 'RECEIVER'
    }
    customerHeaders["x-wu-redirect-mtcn"] = mtcn
    const body = {
        "customer": {
            "name": {
                givenName
            },
            "address": {
                "countryCode": country
            },
            "phoneNumber": [
                {
                    "type": "CELL_PHONE",
                    countryCode,
                    "number": phone
                }
            ],
            "progressiveRegistration": true,
            ...(password && {
                "credential": {
                    password //"Welcome@123"
                }
            }),
            ...((mailNotification) && {
                notification: {
                    mail: true
                }
            })    
        },
    }
    if(token) {
        body.captcha = {
            "answer": null,
            "recaptcha": token
        }
    }
    if(enableWhatsAppOption) {
        body.customer["notification"] = {
            "optInWhatsApp": true
        }
    }
    
    if (email) {
        body.customer.email = email
    }else if (countryCode && phone) {
        body.customer.email = `${countryCode.replace('+', '')}${phone}@WUTEMPMAIL.COM`
    }

    const addNameFields = (body, firstName, surname1, surname2) => {
        if(latinCountries.indexOf(country) !== -1) {
            body.customer["name"] = {
                ...(firstName && {givenName: firstName}),
                ...(surname1 && {maternal : surname1}),
                ...(surname2 && {paternal: surname2})
            }
        } else {
            body.customer["name"] = {
                ...(firstName && {first : firstName}),
                ...(surname1 && {middle : surname1}),
                ...(surname2 && {last : surname2})
            }
        }
    }
    
    addNameFields(body, givenName, surname1, surname2)
    if(!body.customer.name.givenName) {
        delete body.customer.name.givenName
    }
    if(surname1) body.customer.name.maternal = surname1
    if(surname2) body.customer.name.paternal = surname2
    if(!surname1 && !surname2 && !givenName) {
        delete body.customer.name
    }
    
    const requestOptions = {
        method: "POST",
        body: JSON.stringify(body),
        headers: customerHeaders
    };
    try {
        return fetchApiWu('/auth/v2/register/customer', requestOptions, 'partialRegisterCustomer')
            .then((customer) => {
                showSuccessScreen && showSuccessScreen(customer.ok === false)
                return customer
            })
    } catch(e) {
        showSuccessScreen && showSuccessScreen(true)
        console.log(e)
    }
}

window.triggerPartialRegistration = triggerPartialRegistration